import {Button, Input, Option, Select, Typography} from "@material-tailwind/react";
import Dict from "../../../helper/dict";
import React, {useContext, useEffect, useState} from "react";
import DateField from "../../system/dateField"
import "../../../style/datePicker.css"
import {submitAgentRequest, updateAgentRequestPersonalInfo} from "../../../services/agent/agent_request";
import {Toaster} from "../../../helper/Toaster";
import Validator from "../../../helper/validator/Validator";
import {ValidatorProvider} from "../../../helper/validator/ValidatorContext";
import {checkAll} from "../../../helper/validator/Check";
import FileInput from "../../system/fileInput";
import {AgentRequestContext} from "../../../context/agent_context";
import {toast} from "react-toastify";
import {
  agentRequestFieldClass,
  AgentRequestFieldLabel,
  agentRequestInputProps,
  agentRequestPrimaryButtonClass,
  agentRequestSecondaryButtonClass,
} from "./ui";

export function AgentRequestPersonalInfo() {

  const {
    agentRequest,
    setAgentRequest,
    handleNext,
    handlePrev,
    isFirstStep,
    isLastStep,
    allowedStep,
    setAllowedStep,
  } = useContext(AgentRequestContext);


  const [birthDate, setBirthDate] = useState("");
  const [photoFile, setPhotoFile] = useState({name: ""})
  const [photoFileName, setPhotoFileName] = useState("")

  const [isChecked, setIsChecked] = useState(false)

  useEffect(() => {
    setPhotoFileName(photoFile['name'])
  }, [photoFile]);

  useEffect(() => {
    setBirthDate(agentRequest?.birth_date ?? "");
    setPhotoFile((agentRequest?.photo) || {name: ""});
  }, []);

  useEffect(() => {
    setAgentRequest((prev) => ({
      ...prev,
      birth_date: birthDate,
    }));
  }, [birthDate]);

  const save = async () => {
    const data = {
      id: agentRequest.id,
      name: agentRequest.name,
      family: agentRequest.family,
      father_name: agentRequest.father_name,
      national_code: agentRequest.national_code,
      birth_date: agentRequest.birth_date,
      gender: agentRequest.gender,
      photo: photoFile ?? agentRequest.photo,
    };

    setIsChecked(true);
    const res = checkAll();
    if (!res) {
      toast.error("مقادیر الزامی را بر اساس راهنما تکمیل کنید")
      return
    } else {
      if (typeof agentRequest.birth_date === "string") {
        if (agentRequest.birth_date.length === 0) {
          Toaster.failure(null,
            <Typography variant="small">
              وارد کردن تاریخ تولد الزامی است!
            </Typography>);
          return
        }
      }
    }
    let result;

    if (!agentRequest.id) {
      result = await submitAgentRequest(data);
    } else {
      result = await updateAgentRequestPersonalInfo(data);
    }

    if (result.status === 200) {
      // setActiveStep(1);
      if (allowedStep === 0) {
        setAllowedStep(1)
      }
      handleNext(1);
    }

  };

  return (
    <ValidatorProvider>
      <>
        <div className="grid grid-cols-1 gap-x-6 gap-y-5 md:grid-cols-2 xxl:grid-cols-3">

          <div className={agentRequestFieldClass}>
            <AgentRequestFieldLabel htmlFor="agent-name">{Dict('name')}</AgentRequestFieldLabel>
            <Input {...agentRequestInputProps}
                   id="agent-name"
                   value={agentRequest?.name}
                   placeholder={Dict('name')}
                   onChange={(e) => {
                     setAgentRequest((prev) => ({
                       ...prev,
                       name: e.target.value,
                     }));
                   }}
            />
            <Validator isChecked={isChecked} state={agentRequest?.name} rules="required"/>
            <Validator isChecked={isChecked} state={agentRequest?.name} rules="alphabetic"/>
          </div>

          <div className={agentRequestFieldClass}>
            <AgentRequestFieldLabel htmlFor="agent-family">{Dict('family')}</AgentRequestFieldLabel>
            <Input {...agentRequestInputProps}
                   id="agent-family"
                   value={agentRequest?.family}
                   placeholder={Dict('family')}
                   onChange={(e) => {
                     setAgentRequest((prev) => ({
                       ...prev,
                       family: e.target.value,
                     }));
                   }}
            />
            <Validator isChecked={isChecked} state={agentRequest?.family} rules="required"/>
            <Validator isChecked={isChecked} state={agentRequest?.family} rules="alphabetic"/>
          </div>

          <div className={agentRequestFieldClass}>
            <AgentRequestFieldLabel htmlFor="agent-father-name">{Dict('father_name')}</AgentRequestFieldLabel>
            <Input {...agentRequestInputProps}
                   id="agent-father-name"
                   value={agentRequest?.father_name}
                   placeholder={Dict('father_name')}
                   onChange={(e) => {
                     setAgentRequest((prev) => ({
                       ...prev,
                       father_name: e.target.value,
                     }));
                   }}
            />
            <Validator isChecked={isChecked} state={agentRequest?.father_name} rules="required"/>
            <Validator isChecked={isChecked} state={agentRequest?.father_name} rules="alphabetic"/>
          </div>

          <div className={agentRequestFieldClass}>
            <AgentRequestFieldLabel htmlFor="agent-national-code">{Dict('national_code')}</AgentRequestFieldLabel>
            <Input {...agentRequestInputProps}
                   id="agent-national-code"
                   value={agentRequest?.national_code}
                   placeholder={Dict('national_code')}
                   onChange={(e) => {
                     setAgentRequest((prev) => ({
                       ...prev,
                       national_code: e.target.value,
                     }));
                   }}
            />
            <Validator isChecked={isChecked} state={agentRequest?.national_code} rules="required"/>
            <Validator isChecked={isChecked} state={agentRequest?.national_code} rules="num"/>
          </div>

          <div className={agentRequestFieldClass}>
            <AgentRequestFieldLabel>{Dict("birth_date")}</AgentRequestFieldLabel>
            <DateField
              className="w-full"
              date={agentRequest?.birth_date}
              setDate={setBirthDate}
              placeholder={Dict("birth_date")}
              inputProps={agentRequestInputProps}
            />
            <Validator isChecked={isChecked} state={birthDate} rules="required"/>
          </div>

          <div className={agentRequestFieldClass}>
            <AgentRequestFieldLabel>{Dict('gender')}</AgentRequestFieldLabel>
            <Select {...agentRequestInputProps}
                    value={agentRequest?.gender}
                    onChange={(val) =>
                      setAgentRequest((prev) => ({
                        ...prev,
                        gender: val,
                      }))
                    }>
              <Option value="male">مرد</Option>
              <Option value="female">زن</Option>
            </Select>
          </div>

          <div className={`${agentRequestFieldClass} md:col-span-2 xxl:col-span-3`}>
            <FileInput
              id="agent-profile-photo"
              modern
              label={Dict('profile_photo')}
              fileCode={photoFile}
              onChange={(e) => {
                setPhotoFile(e.target.files[0]);
              }}/>
            <Validator isChecked={isChecked} state={(photoFile ?? photoFileName)} rules="required"/>
          </div>

        </div>
        <div className="mt-7 border-t border-app-border pt-4">
          <div className="flex flex-col gap-3 sm:flex-row sm:justify-between">
            <Button className={`w-full sm:w-auto ${agentRequestPrimaryButtonClass}`} onClick={save} disabled={isLastStep}>
              مرحله بعدی
            </Button>
            <Button variant="outlined" className={`w-full sm:w-auto ${agentRequestSecondaryButtonClass}`} onClick={() => {
              handlePrev(0)
            }} disabled={isFirstStep}>
              مرحله قبلی
            </Button>
          </div>
        </div>
      </>
    </ValidatorProvider>
  )
    ;
}
